//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_PERIODOS = "obtenerPeriodos";
export const OBTENER_PERIODO = "obtenerPeriodo";
export const ACTUALIZAR_PERIODO = "actualizarPeriodo";
export const REGISTRAR_PERIODO = "registrarPeriodo";
// mutation types
export const SET_PERIODOS = "setPeriodos";
export const SET_PERIODO = "setPeriodo";

const state = {
    periodos: [],
    periodo:[],
}

const getters = {
    obtenerPeriodos(state) {
      return state.periodos;
    },
}

const actions = {
    /**
     * Obtener Periodos (todos o por estado (activo, incativo, etc))
     * @param {} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_PERIODOS](context, estadoId) {

        let endpoint = 'api/Periodos'
        if(estadoId){
            endpoint = `api/Periodos/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PERIODOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_PERIODO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Periodos/`)
                .then(({ data }) => {
                    context.commit(SET_PERIODO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_PERIODO](context, datosRegion){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Periodos`, datosRegion)
                .then(({ data }) => {
                    context.commit(SET_PERIODO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_PERIODO](context, datosRegion){
        let id = datosRegion.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Periodos/`, datosRegion)
                .then(({ data }) => {
                    context.commit(SET_PERIODO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }
  }

const mutations = {
    [SET_PERIODOS](state, data) {
        state.periodos = data;
    },

    [SET_PERIODO](state, data) {
        state.periodo = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}